export default __webpack_public_path__ + "static/media/Group 2133.1ea25612.png";